import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { AuthenticationProvider } from '@/providers/authentication-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@/i18next';
import './styles/globals.css';
import './styles/bg-animations.css';
import { LanguageProvider } from '@/providers/language-provider';
import { ThemeProvider } from '@/providers/theme-provider';
import { GoogleOAuthProvider } from '@react-oauth/google';
const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    context: {
        authentication: undefined,
    },
});
const applicationId = 'adora_analytic_application';
const Application = () => {
    const authentication = useAuthenticationState();
    return <RouterProvider router={router} context={{ authentication }}/>;
};
const queryClient = new QueryClient();
// Render the app
const rootElement = document.querySelector(`#${applicationId}`);
if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    const clientId = rootElement.getAttribute('data-google-client-id') || '';
    root.render(<StrictMode>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider>
                    <AuthenticationProvider>
                        <GoogleOAuthProvider clientId={clientId}>
                            <LanguageProvider>
                                <Application />
                            </LanguageProvider>
                        </GoogleOAuthProvider>
                    </AuthenticationProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </StrictMode>);
}
